import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions'
import { TextInputField } from 'Automations/nodeDefinitions/components'

export const TextValueInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => (
  <TextInputField
    data-testid={dataTestId ? `${dataTestId}.value` : undefined}
    value={value}
    placeholder="Enter text..."
    onChange={e => onChange({ value: e.target.value })}
    validationErrors={validationErrors}
  />
)
